/**
 * @generated SignedSource<<8d3192ca1c43ae4e3fe1929521f64412>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductExpireBatchesListRefetchableQuery$variables = {
  after?: string | null;
  first?: number | null;
  id: string;
};
export type ProductExpireBatchesListRefetchableQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"ProductExpireBatchesList_StoreProduct">;
  } | null;
};
export type ProductExpireBatchesListRefetchableQuery = {
  response: ProductExpireBatchesListRefetchableQuery$data;
  variables: ProductExpireBatchesListRefetchableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoString",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreZonedDate",
  "kind": "LinkedField",
  "name": "expireAtDate",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v6 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProductExpireBatchesListRefetchableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProductExpireBatchesList_StoreProduct"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProductExpireBatchesListRefetchableQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "StoreProductExpireBatch",
                "kind": "LinkedField",
                "name": "activeExpireBatches",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchAction",
                    "kind": "LinkedField",
                    "name": "activeAction",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "label",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "status",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreZonedDate",
                        "kind": "LinkedField",
                        "name": "startAtDate",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "timezone",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "StoreProductExpireBatchConnection",
                "kind": "LinkedField",
                "name": "inActiveExpireBatches",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "StoreProductExpireBatchEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "StoreProductExpireBatch",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "ProductExpireBatchesList_store_inActiveExpireBatches",
                "kind": "LinkedHandle",
                "name": "inActiveExpireBatches"
              }
            ],
            "type": "StoreProduct",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e32101e63a3339d327de3783f8e8e56",
    "id": null,
    "metadata": {},
    "name": "ProductExpireBatchesListRefetchableQuery",
    "operationKind": "query",
    "text": "query ProductExpireBatchesListRefetchableQuery(\n  $after: String\n  $first: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...ProductExpireBatchesList_StoreProduct\n    id\n  }\n}\n\nfragment ProductExpireBatchListItemAction_StoreProductExpireBatchAction on StoreProductExpireBatchAction {\n  id\n  label\n  status\n  startAtDate {\n    isoString\n    timezone\n    ...StoreRelativeZonedDate_StoreZonedDate\n  }\n}\n\nfragment ProductExpireBatchesList_StoreProduct on StoreProduct {\n  activeExpireBatches {\n    id\n    ...ProductExpireDateListItem_StoreProductExpireBatch\n  }\n  inActiveExpireBatches(first: $first, after: $after) {\n    edges {\n      node {\n        id\n        expireAtDate {\n          isoString\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ProductExpireDateListItem_StoreProductExpireBatch on StoreProductExpireBatch {\n  activeAction {\n    ...ProductExpireBatchListItemAction_StoreProductExpireBatchAction\n    id\n  }\n  expireAtDate {\n    isoString\n  }\n}\n\nfragment StoreRelativeZonedDate_StoreZonedDate on StoreZonedDate {\n  isoString\n  timezone\n}\n"
  }
};
})();

(node as any).hash = "445e2a1b7a6d094c6b0082453bc29fa7";

export default node;
